import { Navigate, useParams } from "react-router";

export const ProtectedRoute=({ children })=> {
  const { id } = useParams();

  // Check if the route is "admin"
  if (id !== "admin") {
    const isAuthenticated = false; 
    if (!isAuthenticated) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
}